import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';
// Types
import { Winner } from 'types/lottery/winner';

export const secondWinnersState = atom<Winner[]>({
  key: ATOM_KEYS.SECOND_WINNERS_STATE,
  default: [],
});
